import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

export default function MainChart({ data }: any) {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        width={500}
        height={280}
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line
          type="monotone"
          dataKey="vehicles"
          stroke="#E50000"
          activeDot={{ r: 8 }}
          strokeWidth={2}
        />
        {/* <Line
          type="monotone"
          dataKey="yesterday"
          stroke="#eb6060"
          strokeWidth={2}
        /> */}
      </LineChart>
    </ResponsiveContainer>
  );
}
